import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.mandant-config-download';
import * as api from '../../../clients/api';

@Injectable()
export class ApiMandantConfigDownloadEffects {

    MandantConfigDownload$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_MANDANT_CONFIG_DOWNLOAD),
        mergeMap((x: ac.GetMandantConfigDownloadAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getMandantConfigDownload().pipe(
                map((result: any) => {
                    return new ac.GetMandantConfigDownloadErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetMandantConfigDownloadFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MandantVerwaltungService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MandantVerwaltungService {
        if (this.service === null) {
            this.service = this.injector.get(api.MandantVerwaltungService);
        }
        return this.service;
    }
}
